import { ImagePlaceholderIconWhite } from 'pages/CreateVehicle/icons/ImagePlaceholder';
import { useCameraViewContext } from '../../context';
import { Image, PlaceholderContainer, PlaceholderWrapper } from './ui';
import { useFieldArray } from 'react-final-form-arrays';

export const GoBackPlaceholder = () => {
  const { cancelRecording, setIndex, level1SectionId, isRecording, isVideoMode } = useCameraViewContext();

  const { fields } = useFieldArray(`${level1SectionId}.images`, { subscription: { length: true } });

  const handleClick = () => {
    if (!isVideoMode) return;
    if (isRecording) cancelRecording();
    setIndex(fields.length! ?? 0);
  };

  return (
    <Image isPlaceholder onClick={handleClick}>
      <PlaceholderContainer>
        <PlaceholderWrapper>
          <ImagePlaceholderIconWhite />
        </PlaceholderWrapper>
      </PlaceholderContainer>
    </Image>
  );
};
